import { render, staticRenderFns } from "./MediaProcessor.vue?vue&type=template&id=2f5b72d1&scoped=true"
import script from "./MediaProcessor.vue?vue&type=script&lang=js"
export * from "./MediaProcessor.vue?vue&type=script&lang=js"
import style0 from "./MediaProcessor.vue?vue&type=style&index=0&id=2f5b72d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b72d1",
  null
  
)

export default component.exports